import { Grid, makeStyles } from "@material-ui/core";
import AttachmentModel from "api/models/AttachmentModel";
import clsx from "clsx";
import DialogModal from "components/UI/DialogModals";
import { lang } from "i18nLang";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { MeasurementAttachmentStore, MessageStore } from "store";
import AttachmentCard from "./AttachmentCard";
import UploadButton from "./UploadButton";

const useStyles = makeStyles({
  container: {
    height: "35vh",
  },
  cardsContainer: {
    marginTop: "0.25rem",
  },
  paddingItem: { padding: "5px 2.5px" },
  loading: { cursor: "wait" },
});

export interface IAttachmentsMeasurementProps {
  measurementId: string;
  open: boolean;
  onClose: () => void;
}

const AttachmentsMeasurement = observer(
  ({ measurementId = "", open, onClose }: IAttachmentsMeasurementProps) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (open) {
        MeasurementAttachmentStore.getMeasurementAttachments(measurementId);
      }
    }, [open]);

    const handleClose = () => {
      MeasurementAttachmentStore.removeAllUnsavedMeasurementAttachment();
      onClose();
    };

    const handleConfirm = async () => {
      setLoading(true);
      MeasurementAttachmentStore.saveMeasurementAttachments(measurementId)
        .then(() => onClose())
        .finally(() => setLoading(false));

      // para não fechar o modal
      return true;
    };

    const handleChangeFiles = (files: File[]) => {
      if (!MeasurementAttachmentStore.validadeAttachmentsCount(files)) {
        MessageStore.error(lang("attachments.errors.maximumFilesCount"));
        return;
      }

      const promises = Array.from(files).map((file) =>
        MeasurementAttachmentStore.uploadMeasurementAttachment(file)
      );
      Promise.all(promises);
    };

    const handleDeleteCard = (attachment: AttachmentModel) => {
      MeasurementAttachmentStore.removeMeasurementAttachment(attachment);
    };

    const getModalTitle = () => {
      if (!measurementId) return lang("attachments.attachFiles");

      const measurement =
        MeasurementAttachmentStore.findMeasurement(measurementId);
      return measurement
        ? measurement.description
        : lang("attachments.attachFiles");
    };

    return (
      <DialogModal
        open={open}
        onClose={handleClose}
        className={clsx({ [classes.loading]: loading })}
        title={getModalTitle()}
        confirmLabel={lang("save")}
        onConfirm={handleConfirm}
        disabledConfirm={MeasurementAttachmentStore.hasFileBeingUploaded()}
      >
        <Grid className={classes.container}>
          <Grid container className={classes.cardsContainer}>
            <Grid item xs={12} className={classes.paddingItem}>
              <UploadButton
                showLabel={true}
                onChangeFiles={handleChangeFiles}
              />
            </Grid>
            {MeasurementAttachmentStore.attachments.map((att) => (
              <Grid item xs={4} className={classes.paddingItem} key={att.uid}>
                <AttachmentCard attachment={att} onDelete={handleDeleteCard} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </DialogModal>
    );
  }
);

export default AttachmentsMeasurement;
